import { GET_CREDS, SELECT_CRED, UPDATE_CRED, MODIFY_SELECTED_CRED, DISCARD_CRED, DELETE_CRED } from "../actions/types";
const initialState = {
  creds: [],
  selectedCred: {},
  unsaved_cred: false,
};
const sort = (flows) => {
  return flows.sort(function (a, b) {
    return new Date(a.created) - new Date(b.created);
  });
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_CREDS:
      return {
        ...state,
        creds: sort(action.payload),
      };
    case SELECT_CRED:
      return {
        ...state,
        selectedCred: action.payload,
      };
    case MODIFY_SELECTED_CRED:
      return {
        ...state,
        selectedCred: action.payload,
        unsaved_cred: true,
      };
    case UPDATE_CRED:
      let creds = state.creds.filter((app) => app.id !== action.payload.id);
      creds.push(action.payload);

      return {
        ...state,
        creds: sort(creds),
        selectedCred: action.payload,
        unsaved_cred: false,
      };
    case DISCARD_CRED:
      return {
        ...state,
        selectedCred: action.payload,
        unsaved_cred: false,
      };
    case DELETE_CRED:
      return {
        ...state,
        creds: sort(state.creds.filter((app) => app.id !== action.payload.id)),
        unsaved_cred: false,
        selectedCred: {},
      };
    default:
      return state;
  }
}
